//////////////////////////////////////////////////////  GLOBAL VARIABLES ////////////////////////////////////////////////////


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////// FUNCTIONS DEFINITIONS ///////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////// GRAB THE RELEVANT HTML PAGE ELEMENTS /////////////////////////////////////////////////////

function grabHtmlContentForMoveItemsIntoPage() {

	return {itemsFromRight: document.querySelectorAll('.moveItemIntoPageFromRightOnPageLoad'),
	itemsFromLeft: document.querySelectorAll('.moveItemIntoPageFromLeftOnPageLoad'),}
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



/////////////////////////// SET THE INITIAL POSITION FOR THE DOC ITEMS TO BE MOVED INTO THE PAGE ON PAGE LOAD //////////////////////////////

function initPositionForItemsToBeMoved() {

	const {itemsFromRight, itemsFromLeft} = grabHtmlContentForMoveItemsIntoPage();
//console.log(itemsFromRight);
//console.log(itemsFromLeft);
		
	itemsFromRight.forEach(item => {
	item.style.setProperty('transform', 'translateX(100vw)');
	})	
		
	itemsFromLeft.forEach(item => {
	item.style.setProperty('transform', 'translateX(-100vw)');
	})	
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////////// MOVE THE DOC ITEMS INTO THE PAGE WHEN SCROLLING TO THEIR LEVEL //////////////////////////////

function moveItemsIntoPage() {

	const {itemsFromRight, itemsFromLeft} = grabHtmlContentForMoveItemsIntoPage();

//console.log("Number of itemsFromRight = " + itemsFromRight.length);
//console.log("Number of itemsFromLeft = " + itemsFromLeft.length);

	let marginTopArticle = new Array(itemsFromRight.length);
	let marginTopArticle_str = new Array(itemsFromRight.length);
	let topPositionArticle = new Array(itemsFromRight.length);

	let marginTopImage = new Array(itemsFromLeft.length);
	let marginTopImage_str = new Array(itemsFromLeft.length);
	let topPositionImage = new Array(itemsFromLeft.length);
	
	const reElSize = /\d+\.?\d*/;
	
	for (let ind=0; ind < itemsFromRight.length; ind++)
		{
		marginTopArticle[ind] = window.getComputedStyle(itemsFromRight[ind]).getPropertyValue('margin-top');
		marginTopArticle_str[ind] = marginTopArticle[ind].match(reElSize);
//console.log(marginTopArticle[ind]);
//console.log(marginTopArticle_str[ind]);
		
		topPositionArticle[ind] = itemsFromRight[ind].getBoundingClientRect().top;
//console.log(topPositionArticle[ind]);

		}

	for (let ind=0; ind < itemsFromLeft.length; ind++)
		{
		marginTopImage[ind] = window.getComputedStyle(itemsFromLeft[ind]).getPropertyValue('margin-top');
		marginTopImage_str[ind] = marginTopImage[ind].match(reElSize);
//console.log(marginTopImage[ind]);
//console.log(marginTopImage_str[ind]);
		
		topPositionImage[ind] = itemsFromLeft[ind].getBoundingClientRect().top;
//console.log(topPositionImage[ind]);

		}

	let LastKnownPos = window.scrollY;

	for (let ind=0; ind < itemsFromRight.length; ind++)
	{

			if ( (window.innerHeight - +marginTopArticle_str[ind]) + LastKnownPos > topPositionArticle[ind] + LastKnownPos )
				{
				itemsFromRight[ind].style.setProperty('transition-property', 'transform');
				itemsFromRight[ind].style.setProperty('transition-duration', '1s');
				/*itemsFromRight[ind].style.setProperty('right', '0vw'); */
				itemsFromRight[ind].style.setProperty('transform', 'translateX(0vw)');
				itemsFromRight[ind].style.setProperty('position', 'static');
				itemsFromRight[ind].classList.remove('moveItemIntoPageFromRightOnPageLoad');
				}
	}
	
	for (let ind=0; ind < itemsFromLeft.length; ind++)
	{

			if ( (window.innerHeight - +marginTopImage_str[ind]) + LastKnownPos > topPositionImage[ind] + LastKnownPos )
				{
				itemsFromLeft[ind].style.setProperty('transition-property', 'transform');
				itemsFromLeft[ind].style.setProperty('transition-duration', '1s');
				/*itemsFromLeft[ind].style.setProperty('left', '0vw'); */
				itemsFromLeft[ind].style.setProperty('transform', 'translateX(0vw)');
				itemsFromLeft[ind].style.setProperty('position', 'static');
				itemsFromLeft[ind].classList.remove('moveItemIntoPageFromLeftOnPageLoad');
				}
	}
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////	EVENT HANDLERS /////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

window.addEventListener('load', () => {
	initPositionForItemsToBeMoved();
	moveItemsIntoPage();
});

window.addEventListener('scroll', moveItemsIntoPage);

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////